const API_BASE_URLS = {
  development: "https://dev.api.hortatech.es",
  production: "https://api.hortatech.es",
  local: "http://localhost:1230",
};

export const getApiBaseUrl = (
  hostname = window.location.hostname,
  override = process.env.REACT_APP_API_BASE_URL
) => {
  if (override) {
    return override;
  }

  if (hostname === "dev.dashboard.hortatech.es") {
    return API_BASE_URLS.development;
  }

  if (hostname === "dashboard.hortatech.es") {
    return API_BASE_URLS.production;
  }

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return API_BASE_URLS.local;
  }
};

export const API_BASE_URL = getApiBaseUrl().replace(/\/$/, "");

export const apiUrl = (path) =>
  `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
